import { Button, Icon } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createLabel, setLabelKey } from '../../actions'
import FormLabel from './components/FormLabel/FormLabel'
import './style.scss'


export class FormData extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      show: false,
    }
  }
  render() {
    const { show } = this.state;
    const { labels, item, formatMessage, labelQuestions, onChangeLabel } = this.props;
    if(show){
      return <FormLabel initialValues={item} onClose={() => this.setState({show: false})} formatMessage={formatMessage} />
    }
    return (
      <div className='LabelFormData'>
        <div className='items'>
          {labels.map(_i => 
            <div key={'lb_' + _i.id} className='item'>
              <div className='label-item' style={{background: _i.color}} onClick={() => onChangeLabel(_i)}>
                {_i.text}
                {labelQuestions.some(_l => _l.label_id == _i.id) && <div className='icon'>
                  <Icon type="check-circle" />
                </div>}
              </div>
              <Button onClick={() => {
                this.props.setLabelKey('item', _i);
                this.setState({show: true});
              }}><Icon type="edit" /></Button>
            </div>
          )}
        </div>
        <Button block type="primary" style={{marginBottom: 20}} onClick={() => {
           this.props.setLabelKey('item', {text: ''});
          this.setState({show: true})
        }}>{formatMessage('addNewLabel')}</Button>
        <Button block onClick={() => {
           this.props.onClose()
        }}>{formatMessage('btnCloselabel')}</Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  labels: state.label.list,
  item: state.label.item,
})

const mapDispatchToProps = {
  createLabel,
  setLabelKey,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormData)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/components/FormData/FormData.jsx